import PropTypes from 'prop-types';
import StripeCardProp from '../../profile/propTypes/StripeCardProp';
import PriceProp from '../../../commonComponents/propTypes/priceProp';

export const STEP_PLAN_CHECKOUT = {
  ORDER: 'order',
  BILLING: 'billing',
  PAYMENT: 'payment',
};

const propType = {
  createdAt: PropTypes.number,
  creditCard: PropTypes.shape(StripeCardProp.propType),
  currentUserPlan: PropTypes.string,
  deleted: PropTypes.bool,
  historyUserPlans: PropTypes.array,
  organization: PropTypes.string,
  owner: PropTypes.string,
  paymentMethodId: PropTypes.string,
  startDate: PropTypes.number,
  status: PropTypes.string,
  interval: PropTypes.string,
  stripeSubscription: PropTypes.object,
  subscriptionStripeId: PropTypes.string,
  tenant: PropTypes.string,
  updatedAt: PropTypes.number,
  _id: PropTypes.string,
  userPrice: PropTypes.shape(PriceProp.propType),
};

export default { propType };
